import { useMemo, useCallback, useState } from 'react';
import type {
  IApiColumnConfig,
  IBondScreenerConfig,
  IBondScreenerPresetConfig,
} from '@/creditflowresearch/domain/vo/Bondscreener';

export interface IBondScreenerColumnsState {
  allColumns: readonly IApiColumnConfig[],
  columnsMap: ReadonlyMap<string, IApiColumnConfig>,
  activeColumnsIds: readonly string[],
  defaultColumnsIds: readonly string[],
  setActiveColumnsIds: (ids: string[]) => void,
  resetToDefaults: () => void,
  presets: readonly IBondScreenerPresetConfig[],
}

export const useBondScreenerColumns = (
  config: IBondScreenerConfig,
  initialActiveColumnsIds?: string[],
): IBondScreenerColumnsState => {
  const allColumns = config.columns;

  const columnsMap = useMemo(
    () => new Map(allColumns.map((col) => [col.id, col])),
    [allColumns],
  );

  const defaultColumnsIds = useMemo(
    () => [...config.default.columns],
    [config],
  );

  const [activeColumnsIds, setActiveColumnsIds] = useState<string[]>(
    () => [...(initialActiveColumnsIds ?? config.default.columns)],
  );

  const resetToDefaults = useCallback(() => {
    setActiveColumnsIds(defaultColumnsIds);
  }, [defaultColumnsIds]);

  return useMemo(() => ({
    allColumns,
    columnsMap,
    activeColumnsIds,
    defaultColumnsIds,
    setActiveColumnsIds,
    resetToDefaults,
    presets: config.presets,
  }), [allColumns, columnsMap, activeColumnsIds, defaultColumnsIds, setActiveColumnsIds, resetToDefaults, config]);
};
